import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import InactiveHeaderImage from '@pages/inactiveUser/images/InactiveHeaderImage';
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router-dom';
import ServiceBox from './components/ServiceBox';
import useRequestTermsService from './hooks/useRequestTermsService';
import RequestTermsStyles from './RequestTerms.style';

const RequestTerms = () => {
  const { t } = useTranslation();
  const {
    acceptedTerms,
    name,
    lastName,
    termsAccepted,
    openTermsByCountry,
    setTermsAccepted,
    updateTermsByUser,
  } = useRequestTermsService();

  if (acceptedTerms) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <>
      <div className={RequestTermsStyles.wrapper}>
        <InactiveHeaderImage />
        <Typography variant="h4" sx={{ typography: { sm: 'h4', xs: 'h5' } }}>
          {t('requestUserTermsPageTitle')}
        </Typography>
        <Typography className={RequestTermsStyles.text} variant="body2">
          {t('requestUserTermsMessage1')}{' '}
          <Typography
            variant="body2"
            component="span"
            className={RequestTermsStyles.boldText}
          >
            {name} {lastName}
          </Typography>{' '}
          {t('requestUserTermsMessage2')}
        </Typography>
        <Card className={RequestTermsStyles.cardWrapper}>
          <CardContent>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={termsAccepted}
                    onChange={(_, checked) => setTermsAccepted(checked)}
                  />
                }
                label={
                  <Typography
                    className={RequestTermsStyles.termsText}
                    variant="body2"
                  >
                    {t('requestUserTermsAccept')}
                    <Button
                      className={RequestTermsStyles.termsButton}
                      onClick={() => openTermsByCountry()}
                      variant="text"
                    >
                      {t('requestUserTermsLink')}
                    </Button>
                  </Typography>
                }
              />
            </FormGroup>
            <Typography
              className={RequestTermsStyles.termsBody}
              variant="body2"
            >
              {t('requestUserTermsMessage3')}
              <Button
                className={RequestTermsStyles.termsBodyButton}
                onClick={() => openTermsByCountry()}
                variant="text"
              >
                {t('requestUserTermsLink')}
              </Button>
              {t('requestUserTermsMessage4')}{' '}
              <Link
                className={RequestTermsStyles.termsBodyLink}
                to="https://legal.efexpay.com/"
                target="_blank"
              >
                {t('requestUserLegalPageLink')}{' '}
              </Link>
              {t('requestUserTermsMessage5')}
            </Typography>
          </CardContent>
        </Card>
        <Button
          variant="contained"
          className={RequestTermsStyles.actionButton}
          disabled={!termsAccepted}
          onClick={() => updateTermsByUser({ termsAccepted })}
        >
          {t('activateReturnDashboard')}
        </Button>
      </div>
      <ServiceBox />
    </>
  );
};

export default RequestTerms;
